import './App.css'

import { Box, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useRoutes } from 'react-router-dom'

import ReloadPrompt from './app/base/components/ReloadPrompt/ReloadPrompt'
import MatxTheme from './app/base/components/Template/MatxTheme/MatxTheme'
import { AppConfirmProvider } from './app/base/contexts/AppConfirmProvider.tsx'
import { BreadcrumbProvider } from './app/base/contexts/BreadcrumbContext'
import { ErrorProvider } from './app/base/contexts/ErrorProvider.tsx'
import { AuthProvider } from './app/base/contexts/JWTAuthContext'
import { SecurityProvider } from './app/base/contexts/SecurityContext'
import { SettingsProvider } from './app/base/contexts/SettingsContext.tsx'
import { ToastProvider } from './app/base/contexts/ToastContext.tsx'
import ImpresionDocumentoProvider from './app/modules/base/Impresora/components/ImpresionDocumentoProvider'
import WaapiImpresionAccion from './app/modules/base/waapi/components/WaapiImpresionAccion'
import { appRoutes } from './app/routes/routes'

/**
 * @author isi-template
 * @constructor
 */
function App() {
  const content = useRoutes(appRoutes)
  const link = document.querySelector('link[rel="icon"]')
  const version = import.meta.env.ISI_VERSION

  const isDebugMode =
    import.meta.env.ISI_DEBUG === true ||
    import.meta.env.ISI_DEBUG === 'true' ||
    import.meta.env.ISI_DEBUG === '1'

  useEffect(() => {
    if (link) {
      if (import.meta.env.ISI_FAVICON) {
        link.setAttribute('href', import.meta.env.ISI_FAVICON)
      }
    }

    console.clear()

    // Mensaje de advertencia con estilos en la consola
    const appName = import.meta.env.ISI_TITLE || 'ISI-PAY'
    const appVersion = import.meta.env.ISI_VERSION || version
    const message = `%c ¡Atención! Estás utilizando la aplicación para ${appName}. Versión: ${appVersion}`
    const styles = [
      'color: #ff9800', // Naranja Amber
      'font-size: 1.2em',
      'font-weight: bold',
    ].join(';')

    console.log(message, styles)
  }, [version, link])

  return (
    <SettingsProvider>
      {/* Tema, toasts y errores no dependen de la sesión: van sobre AuthProvider para que pueda usarlos */}
      <MatxTheme>
        <ToastProvider defaultOptions={{ position: 'center_top' }}>
          <ErrorProvider>
            <AuthProvider>
              <BreadcrumbProvider>
                <SecurityProvider>
                  <AppConfirmProvider
                    defaultOptions={{
                      title: 'Autorización',
                      content: '¿Proceder con la solicitud?',
                      confirmationText: 'Aceptar',
                      cancellationText: 'Cancelar',
                      showInput: false,
                      disableCloseOnOverlay: false,
                    }}
                  >
                    {isDebugMode && (
                      <Box
                        sx={{
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          zIndex: 9999,
                          pointerEvents: 'none',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          overflow: 'hidden',
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: {
                              xs: '140px',
                              sm: '180px',
                              md: '220px',
                            },
                            fontWeight: 100,
                            color: 'rgba(0, 0, 0, 0.04)',
                            textTransform: 'uppercase',
                            letterSpacing: '30px',
                            userSelect: 'none',
                            transform: 'rotate(-45deg)',
                          }}
                        >
                          SANDBOX
                        </Typography>
                      </Box>
                    )}

                    <ImpresionDocumentoProvider accionesExtra={(ctx) => <WaapiImpresionAccion {...ctx} />}>
                      {content}
                    </ImpresionDocumentoProvider>
                    <ReloadPrompt />
                  </AppConfirmProvider>
                </SecurityProvider>
              </BreadcrumbProvider>
            </AuthProvider>
          </ErrorProvider>
        </ToastProvider>
      </MatxTheme>
    </SettingsProvider>
  )
}

export default App
